// @flow
import React from 'react';
import { PrimaryButton } from '@presentational/buttons/PrimaryButton';
import {
  getConfiguredMetricRowsFromFormikValues,
  getIfAnyRowIsBeingEditedAnyWhereInAnyMetric,
  getIfAnyRowMetricNameAsNull,
  getUnusedCommittedCapacityMetricsList,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';
import { useFormikContext } from 'formik';

export const AddNewMetricButton = ({ metricLevelArrayHelpers }) => {
  const { values: formikValues } = useFormikContext();
  const configuredMetricRows = getConfiguredMetricRowsFromFormikValues(formikValues);
  const unusedMetricsList = getUnusedCommittedCapacityMetricsList(configuredMetricRows);

  // User should not be able to add a new metric when there is work happening on any row in the already added metric
  // Also, when the user has clicked on Add Metric and has not chosen a metric yet, it should be disabled
  // Finally, if there are no more metrics to be configured, we need to disable it
  const shouldAddMetricBeDisabled =
    getIfAnyRowIsBeingEditedAnyWhereInAnyMetric(configuredMetricRows) ||
    getIfAnyRowMetricNameAsNull(configuredMetricRows) ||
    unusedMetricsList.length === 0;

  return (
    <PrimaryButton
      disabled={shouldAddMetricBeDisabled}
      floated="right"
      onClick={() => {
        const newRow = {
          metricName: null,
          metricId: '-1',
        };
        return metricLevelArrayHelpers.push(newRow);
      }}
      text="+ Add Metric"
    />
  );
};
